import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import Overlay from "web/script/utils/overlay";
import userProfiler from "web/script/modules/userprofiler";

const ANSWER_YES = "something-went-wrong";
const ANSWER_NO = "everything-was-fine";

export const DATA_SURVEY_RESPONSE_OPTIONS = [
    {
        value: "response_size_not_available",
        text: "The product wasn't available in my size",
    },
    {
        value: "response_sold_out",
        text: "The product was sold out",
    },
    {
        value: "response_price_mismatch",
        text: "The price didn't match the one I saw on Lyst",
    },
    {
        value: "response_wrong_page",
        text: "I was taken to the wrong page or product",
    },
    {
        value: "response_retailer_not_working",
        text: "The retailer was difficult to use or not working",
    },
];

let dataSurveyOverlay;

function closeDataSurvey() {
    if (dataSurveyOverlay) {
        dataSurveyOverlay.close();
    }
}

export function showDataSurvey(retailerName) {
    const surveyShown = userProfiler.getSurveyShown();

    if (surveyShown | !retailerName) {
        return;
    }

    import(
        /* webpackChunkName: "template-surveys-data-survey" */
        "templates/surveys/data-survey"
    ).then(({ default: dataSurveyTemplate }) => {
        dataSurveyOverlay = new Overlay({
            cssClasses: ["size-m", "white"],
            content: dataSurveyTemplate({
                retailerName,
                responses: DATA_SURVEY_RESPONSE_OPTIONS,
            }),
            onRenderFinish: () => {
                analytics.event("data-survey", "open");
                userProfiler.setSurveyShown();
            },
            onOverlayClose: () => {
                analytics.event("data-survey", "close");
            },
        });
    });
}

export default baustein.register("data-survey", {
    setupEvents(add) {
        add("click", ".data-survey-answer__no", this.onClickNo);
        add("click", ".data-survey-answer__yes", this.onClickYes);
        add("submit", ".data-survey__form", this.onSubmit);
        add("change", ".data-survey__form", () => this.selectYes());
        add("click", ".data-survey-response__other-text", () => {
            this.el
                .querySelector(".data-survey-response__other-input")
                .setAttribute("checked", "checked");
            this.selectYes();
        });
        add("click", ".data-survey-response__other", () => {
            this.el.querySelector(".data-survey-response__other-text").focus();
        });
    },

    selectNo() {
        this.inactiveBtn(this.el.querySelector(".data-survey-answer__yes"));
        this.activeBtn(this.el.querySelector(".data-survey-answer__no"));
        this.el.dataset.answer = ANSWER_NO;
        this.enableSubmit();
        this.disableForm();
    },

    selectYes() {
        this.inactiveBtn(this.el.querySelector(".data-survey-answer__no"));
        this.activeBtn(this.el.querySelector(".data-survey-answer__yes"));
        this.enableSubmit();
        this.el.dataset.answer = ANSWER_YES;
        this.enableForm();
    },

    onSubmit() {
        var form = this.el.querySelector(".data-survey__form");
        const answer = this.el.dataset.answer;

        let payload = {
            response_something_else: form.response_other.value,
            answer,
        };

        form.response.forEach((r) => {
            payload[r.value] = r.checked;
        });

        analytics.trackWithMetaData("data_survey_response", payload);
        analytics.event("data-survey", "submit", answer);

        this.close();
    },

    enableSubmit() {
        this.el.querySelector(".data-survey__submit").removeAttribute("disabled");
    },

    activeBtn(el) {
        el.classList.remove("btn--grey");
        el.classList.add("btn--blue");
    },

    inactiveBtn(el) {
        el.classList.add("btn--grey");
        el.classList.remove("btn--blue");
    },

    disableForm() {
        this.el.querySelector(".data-survey__form").classList.remove("something-went-wrong");
        var boxes = this.el.querySelectorAll(".data-survey-response__box");
        for (var el of boxes) {
            el.classList.add("glyph-tick-white");
            el.classList.remove("glyph-tick-blue");
        }
    },

    enableForm() {
        this.el.querySelector(".data-survey__form").classList.add("something-went-wrong");
        var boxes = this.el.querySelectorAll(".data-survey-response__box");
        for (var el of boxes) {
            el.classList.add("glyph-tick-blue");
            el.classList.remove("glyph-tick-white");
        }
    },

    onClickNo() {
        this.selectNo();
        analytics.event("data-survey", "click", ANSWER_NO);
    },

    onClickYes() {
        this.selectYes();
        analytics.event("data-survey", "click", ANSWER_YES);
    },

    close() {
        closeDataSurvey();
        this.destroy();
    },
});
